/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Component } from "react";
// import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

import PublicLayout from "../../containers/Layout/PublicLayout";
import SignUpForm from "../../containers/SignUpForm";
import SignUpFormPart2 from "../../containers/SignUpForm/part2";

import Label from "../../components/label";
import appRoutes from "../../routes/appRoutes";

// import makeRequest from "../../apiCalls/common";
import {
  registerPartOne,
  appConstants
} from "../../apiRoutes";

import Model from "../../components/modal";

import deviceCheck from "../../utils/checkDevice";

import MakeAPICall from "../../apiCalls/common";
import {STATE_LIST} from "../../constants/helperConstants";

class SignUpPage extends Component {
  constructor() {
    super();
    this.state = {
      form2Active: false,
      form1Filled: false,
      form1Close: false,
      errorModel: false,
      errorMessage:
        "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists.",
      errorTitle: "Instant Consult",
      deviceType: null,
      apiCall: null,
      apiCall2: null,
      appConstantList: null
    };
  }

  onSignUpFormSubmit = formValues => {
    console.log("Sign up form submitted : ", formValues);
    let bodyData = new FormData();
    bodyData.append("firstName", formValues.firstName);
    bodyData.append("middleName", formValues.middleName);
    bodyData.append("lastName", formValues.lastName);
    bodyData.append("email", formValues.email);
    bodyData.append("dateOfBirth", formValues.dateOfBirth);
    bodyData.append("gender", formValues.gender);
    bodyData.append("phoneNumber", formValues.phoneNumber);
    bodyData.append("streetNumber", formValues.streetNumber);
    bodyData.append("streetName", formValues.streetName);
    bodyData.append("suburb", formValues.suburb);
    bodyData.append("state", formValues.state);
    bodyData.append("postCode", formValues.postCode);
    bodyData.append("photoId", formValues.photoId);
    bodyData.append("photoIdThumb", formValues.photoIdThumb);
    bodyData.append("profilePic", formValues.profilePic);
    bodyData.append("profilePicThumb", formValues.profilePicThumb);
    bodyData.append("password", formValues.password);
    bodyData.append("isFile", formValues.isFile);
    bodyData.append("deviceType", this.state.deviceType);
    bodyData.append("appVersion", formValues.appVersion);
    bodyData.append("deviceToken", formValues.deviceToken);

    let apiCallParam = {
      reqType: "POST",
      reqURL: registerPartOne,
      dataObj: bodyData,
      params: {},
      headers: {},
      successCallback: res => {
        this.setState({
          form1Filled: true,
          form2Active: true,
          form1Close: true
        });
      },
      failureCallback: error => {
        console.log("Something went wrong, Please try again. ", error);
        // this.setState({
        //   errorMessage: error.message
        //     ? error.message
        //     : "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // });
        // this.setState({ errorModel: true });
      },
      showPopUp: false,
      showErrPopUp: true
    };
    this.setState({
      apiCall: apiCallParam
    });
  };

  onSignUpFormPart2Submit = formValues => {
    this.props.history.push(appRoutes.signUpSuccess);
  };

  errorModelClose = () => {
    this.setState({ errorModel: false });
  };

  componentDidMount() {
    let deviceInfo = deviceCheck();
    console.log("Device INfo is here : ", deviceInfo);
    if (deviceInfo.name === "chrome") {
      this.setState({ deviceType: 2 });
      // $scope.deviceType=2;
    } else if (deviceInfo.name === "safari" || deviceInfo.name === "mozilla") {
      this.setState({ deviceType: 3 });
    }

    // get constants
    let apiCallParam2 = {
      reqType: "GET",
      reqURL: appConstants,
      dataObj: {},
      params: {},
      headers: {},
      successCallback: res => {
        this.setState({ appConstantList: res.data.data });
        console.log("Got the constats here : ", res.data.data);
      },
      failureCallback: err => {
        console.log("Something went wrong, Please try again. ", err);
      },
      showPopUp: false
    };

    this.setState({
      apiCall2: apiCallParam2
    });
  }

  openForm1 = () => {
    this.setState({ form1Close: false });
  };

  closeForm1 = () => {
    this.setState({ form1Close: true });
  };

  handleFileUpload = error => {
    this.setState({
      errorMessage: error && error.message
        ? error.message
        : "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
    });
    this.setState({ errorModel: true });
  };

  signUpFormFileUpload = data => {
    this.setState({ apiCall: data });
  };

  render() {
    return (
      <PublicLayout>
        <div className="container sign-up-page pt-5 pb-5">
          <div className="container">
            {/* Step 1 */}
            <div className="row step-1 bg-white">
              <div className="col-sm-12 header p-2 pl-3">
                <Label className="large text-white" title="1. Sign Up" />
                <i
                  className={
                    this.state.form1Filled && this.state.form1Close
                      ? "fas fa-angle-down float-right mr-3 text-white fa-2x cursor-pointer"
                      : "d-none"
                  }
                  onClick={this.openForm1}
                ></i>
                <i
                  className={
                    this.state.form1Filled && !this.state.form1Close
                      ? "fas fa-angle-up float-right mr-3 text-white fa-2x cursor-pointer"
                      : "d-none"
                  }
                  onClick={this.closeForm1}
                ></i>
              </div>
              <div
                className={
                  this.state.form1Close ? "d-none" : "col-sm-12 p-2 pl-3 pr-3"
                }
              >
                <SignUpForm
                  onFormSubmit={this.onSignUpFormSubmit}
                  stateList={STATE_LIST}
                  form1Filled={this.state.form1Filled}
                  errorFileUpload={this.handleFileUpload}
                  fileUploadRequest={this.signUpFormFileUpload}
                />
              </div>
            </div>

            {/* Step 2 */}

            <div
              className={
                !this.state.form2Active ? "d-none" : "row step-2 mt-2 bg-white"
              }
            >
              <div className="col-sm-12 header p-2 pl-3">
                <Label className="large text-white" title="2. Agreement" />
              </div>
              <div className="col-sm-12 p-2 pl-3 pr-3 step-2-form">
                <SignUpFormPart2
                  docsUrls={this.state.appConstantList}
                  onFormSubmit={this.onSignUpFormPart2Submit}
                />
              </div>
            </div>

            <div className="row bg-white p-4">
              <div className="col-sm-12 text-center">
                <Label className="gray" title="Already have an account?" />
                <NavLink
                  to={appRoutes.login}
                  className="insta-link-orange font-15 text-decoration-none"
                  href="#"
                >
                  <span className="ml-2 pt-1">Login</span>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
        <Model
          openModal={this.state.errorModel}
          modalBodyContent={this.state.errorMessage}
          okayText="Okay"
          cancelText="Okay"
          title={this.state.errorTitle}
          useOneButton={true}
          okayEvent={this.errorModelClose}
          cancelEvent={this.errorModelClose}
        />
        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />
        <MakeAPICall apiParam={this.state.apiCall2} />
      </PublicLayout>
    );
  }
}

export default SignUpPage;

// const mapStateToProps = state => ({});

// const mapDispatchToProps = dispatch => ({});

// export default connect(mapStateToProps, mapDispatchToProps)(SignUpPage);
